import React, { useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Input, Label, Button, Form, Alert, Table, Container } from "reactstrap";
import { post, put } from "../../helpers/api_helper";
import UploadImage from "common/uploadImage";
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { Trans } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { VEHICLES_SEARCH, REASONS_SEARCH, UPDATE_DOCUMENT_STATUS, UPDATE_DOCUMENT, ADD_VEHICLE_DOCUMENT } from "helpers/api_endpoints";
import Select from "react-select";


//meta title
document.title = "Add Vehicle Document";

const AddVehicleDocument = () => {

    const [status, setStatus] = useState();
    const [reason, setReason] = useState();
    const [documentName, setDocumentName] = useState();
    const [documentStatus, setDocumentStatus] = useState([{value:0,label:"Pending"},{value:1,label:"Accepted"},{value:2,label:"Rejected"}]);
    const [vehicle, setVehicle] = useState({document:[]});
    const [vehicles, setVehicles] = useState([]);
    const [reasons, setReasons] = useState([]);
    const [documents, setDocuments] = useState([]);
    const [vehiclesOption, setVehiclesOption] = useState([]);
    const [errorMsg, seterrorMsg] = useState('');
    const [loading, setLoading] = useState(true);
    const navigate = useNavigate();

    useEffect(() => { 
        post(`${VEHICLES_SEARCH}`, {})
            .then(response => {
                const data = response.data;
                setVehicles(data.map(el => {
                    return {id:el.id, name:el.name, document:el.document}
                }));
                setVehiclesOption(response.data.map(el=>{
                    return {value:el.id,label:el.name}
                }));
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })
        post(`${REASONS_SEARCH}`, {refId:"7"})
            .then(response => {
                setReasons(response.data.map(el=>{
                    return {value:el.id,label:el.nameTranslated}
                }));
                setLoading(false);
            })
            .catch(error => {
                if (error.response.status == 400) {
                    navigate('/logout');
                }
            })


    }, []);

    useEffect(() => {
        setDocuments(vehicle.document.map(el=>{
            if(el == undefined) return;
            el.statusOption = {value:el.status,label:(el.status==0?'Pending':(el.status==1?'Accepted':'Rejected'))};
            if(reasons && reasons != undefined && el.reasonId)
                el.reasonOption = {value:el.reasonId,label:reasons.find(r=>r.value==el.reasonId).label};
            return el;
        }));    
    }, [vehicle]);
    useEffect(() => { 
        setDocuments(vehicle.document.map(el=>{console.log(reasons.find(r=>r.value==el.reasonId))
            if(reasons && reasons != undefined)
                el.reasonOption = {value:el.reasonId,label:reasons.find(r=>r.value==el.reasonId).label};
            return el;
        }));    
    }, [reasons]);

    const handleSubmit = () => {
        
    }

    const handleFilter = (type, value, index = 0) => {
        if (type === 'vehicleId') {
            setVehicle(vehicles.find(vehicle => vehicle.id === value));
        } 
        else if (type === 'documentName') {
            setDocumentName(value);
        } 
        else if (type === 'documentStatus') {
            const temp = documents.map(el => {
                if (el.id === index) {
                    el.status = value;
                    el.statusOption = {
                        value: el.status,
                        label: el.status === 0 ? 'Pending' : el.status === 1 ? 'Accepted' : 'Rejected'
                    };
                    if (value === 2) { // Rejected
                        if (!el.reasonId) {
                            seterrorMsg('Please select a reason after marking as Rejected.');
                            setTimeout(() => seterrorMsg(''), 2500);
                        } else {
                            post(`${UPDATE_DOCUMENT_STATUS}`, { id: el.id, status: 2, reasonId: el.reasonId, vehicleId: vehicle?.id });
                        }
                    } else {
                        // Pending or Accepted
                        post(`${UPDATE_DOCUMENT_STATUS}`, { id: el.id, status: value, vehicleId: vehicle?.id, f:1 });
                    }
                }
                return el;
            });
            setDocuments(temp);
        } 
        else if (type === 'reasons') {
            const temp = documents.map(el => {
                if (el.id === index) {
                    el.reasonId = value;
                    el.reasonOption = {
                        value: el.reasonId,
                        label: reasons.find(r => r.value === el.reasonId)?.label
                    };
    
                    post(`${UPDATE_DOCUMENT_STATUS}`, { id: el.id, reasonId: value, vehicleId: vehicle.id });
    
                    // If already rejected, ensure status update is not missed
                    if (el.status === 2) {
                        post(`${UPDATE_DOCUMENT_STATUS}`, { id: el.id, status: 2, vehicleId: vehicle.id });
                    }
                }
                return el;
            });
            setDocuments(temp);
        }
    
        return true;
    };

    const handleDocumentUpload = (event, documentId) => {
        setLoading(true);
        const file = event.target.files[0];
        if(file.size > 1*1024*1024)
        {
            seterrorMsg('File size is larger than 1MB');
            setTimeout(()=>{
                seterrorMsg('');
            },1700);
            return;
        }
        console.log('file.type', file.type)
        if(file.type != 'image/jpeg' && file.type != 'image/png')
        {
            seterrorMsg('File type is incorrect');
            setTimeout(()=>{
                seterrorMsg('');
            },1700);
            return
        }
        put(`${UPDATE_DOCUMENT}`, { file, id: documentId }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setLoading(false);
                const docs = structuredClone(documents);
                const doc = docs.find(el => el.id == documentId);
                doc.filePath = data.data.fl;
                setDocuments(docs);
                // window.location.reload();
            })
            .catch((error) => {
            });
    }

    const handleFileUpload = (event) => {
        setLoading(true);
        const file = event.target.files[0];
        if(file.size > 1*1024*1024)
        {
            seterrorMsg('File size is larger than 1MB');
            setTimeout(()=>{
                seterrorMsg('');
            },1700);
            return;
        }
        if(file.type != 'image/jpeg' && file.type != 'image/png')
        {
            seterrorMsg('File type is incorrect');
            setTimeout(()=>{
                seterrorMsg('');
            },1700);
            return;
        }

        post(`${ADD_VEHICLE_DOCUMENT}`, { file, type:"1", vehicleId: vehicle.id, name: documentName, status:'0' }, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        })
            .then((response) => {
                const data = response.data;
                setLoading(false);
                window.location.reload();
            })
            .catch((error) => {
            });
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Documents" breadcrumbItem="Add Document" />
                    <Form
                        className="form-horizontal"
                        onSubmit={(e) => {
                            e.preventDefault();
                            handleSubmit();
                            return false;
                        }}
                    >
                        <Row>
                            <Col xl={12}>
                                <Card>
                                    <CardBody>
                                        <Row>
                                            {errorMsg ? <Alert color="danger">{errorMsg}</Alert> : null}
                                            <div className="form-group col-md-2 mt-2">
                                                <Label className="form-label"><Trans>Driver</Trans></Label>
                                                <Select
                                                name="vehicleId"
                                                value={vehiclesOption.filter(option => {return vehicle.id==option.value})}
                                                options={vehiclesOption} 
                                                className="form-control select2"
                                                onChange={(e) => handleFilter('vehicleId', e.value)}
                                                />
                                            </div>

                                            <div className="form-group col-md-4 mt-2">
                                            <Label className="form-label"><Trans>Add Document</Trans></Label>
                                                    <Input
                                                        name="documentName"
                                                        // value={capacity}
                                                        className="form-control"
                                                        placeholder="Enter Name"
                                                        type="text"
                                                        onChange={(e) => handleFilter('documentName',e.target.value)}
                                                    ></Input>
                                                    <input className="form-control" type="file" onChange={handleFileUpload} />
                                            </div>


                                        </Row>
                                        <Card>
                                        <CardBody>
                                       
                                        <Row className="justify-content-center">
                                        {/* <Alert color="secured">{vehicle.name}</Alert> */}
                                        {
                                            documents.map((document, index) => (
                                                <Col className="mb-2" key={index} sm={12} md={4} lg={4}>
                                                    <Row>
                                                        <div>
                                                            <div className="form-group  mt-2">
                                                                    <img src={document.filePath} width={'100%'}/>
                                                                    <input className="form-control" type="file" onChange={(e) => handleDocumentUpload(e, document.id)} />
                                                            </div>

                                                        </div>
                                                        <div >
                                                            <div className="form-group mt-2">
                                                                <Label className="form-label"><Trans>{document.name}</Trans></Label>
                                                                <Select
                                                                name="driverId"
                                                                value={document.statusOption}
                                                                options={documentStatus} 
                                                                className="form-control select2"
                                                                onChange={(e) => handleFilter('documentStatus', e.value, document.id)}
                                                                />
                                                                <Select
                                                                isDisabled={document.status!='2'}
                                                                name="reasonId"
                                                                value={document.reasonOption}
                                                                options={reasons} 
                                                                className="form-control select2"
                                                                onChange={(e) => handleFilter('reasons', e.value, document.id)}
                                                                />
                                                            </div>
                                                        </div>
                                                    </Row>
                                                </Col>
                                            )            
                                            )
                                        }
                                        </Row>
                                        
                                        </CardBody>
                                        </Card>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                </div>
            </div>
        </React.Fragment>
    )
}

export default AddVehicleDocument
